import(/* webpackMode: "eager", webpackExports: ["VaultsProvider"] */ "/vercel/path1/app/api/protocol/vaults/vaults-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path1/app/earn/components/header.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path1/app/earn/components/vault-grid.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["VaultGrid"] */ "/vercel/path1/app/earn/components/vault-grid.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path1/app/earn/page.module.scss");
